import axios, { AxiosRequestConfig, AxiosResponse } from "axios";
import {
  LocalStorage,
  getCredential,
  logOut
} from "./endpoints/user/credentials";
import { BaseQueryFn } from "@reduxjs/toolkit/dist/query";

export type Timestamp = {
  createdAt: moment.Moment;
  updatedAt: moment.Moment;
};

export type BaseItem = {
  id: number;
};

export enum Sort {
  ASCENDING = "ASC",
  DESCENDING = " DESC"
}

const instance = axios.create({
  baseURL: process.env.REACT_APP_BACKEND_BASE_URL,
  maxContentLength: 250 * 1024 * 1024, // 250MB
  maxBodyLength: 250 * 1024 * 1024, // 250MB
  timeout: 300000 // 5 minutes timeout for large uploads
});

// Insert the access token in the request headers
instance.interceptors.request.use(request => {
  request.headers.Authorization = `Bearer ${getCredential(
    LocalStorage.ACCESS_TOKEN
  )}`;
  return request;
});

// Intercept API requests to display status toasts (if need be)
instance.interceptors.response.use(
  response => response,
  error => {
    // Then logout if auth failed
    if (
      getCredential("ctb_user_accessToken") !== undefined &&
      error.response?.status === 401
    ) {
      logOut();
    }

    return Promise.reject(error);
  }
);

export const axiosBaseQuery =
  (
    { baseUrl }: { baseUrl: string } = { baseUrl: "" }
  ): BaseQueryFn<
    {
      url: string;
      method: AxiosRequestConfig["method"];
      data?: AxiosRequestConfig["data"];
      params?: AxiosRequestConfig["params"];
    },
    AxiosResponse["data"],
    unknown
  > =>
    async ({ url, method, data, params }) => {
      try {
        console.log(`API Request: ${method} ${baseUrl + url}`, { data, params });
        const result = await instance({
          url: baseUrl + url,
          method,
          data,
          params
        });

        return { data: result.data };
      } catch (error: any) {
        return {
          error: error.response?.data || error.message
        };
      }
    };


export default instance;
